import { Component } from '@angular/core';
import { MENU_PAGE } from '../shared/defines/desktop.const';

@Component({
  selector: 'app-loanword',
  templateUrl: './loanword.component.html',
  styleUrls: ['./loanword.component.scss']
})
export class LoanwordComponent {

  MENU_PAGE = MENU_PAGE;
}
